import { useLocation } from 'react-router';

import {
  safeLocalStorageParse,
  safeLocalStorageRead,
  safeLocalStorageRemove,
  safeLocalStorageWrite,
} from '@/lib/storage/localStorage';

export const SIMULATIONS_LAST_TAB_KEY = 'simulations_last_tab';

const CREATE_SIMULATION_PARAM = 'create_simulation';
const CREATE_SIMULATION_CONTEXT_KEY = 'simulations_create_context';

interface StashedCreateRequest {
  id: string;
  startingContext: string;
  transcript: string;
}

export type CarriedCreateRequest = Omit<StashedCreateRequest, 'id'>;

export const simulationsListPath = (slug: string | null, brainId: string | null) =>
  slug && brainId ? `/${slug}/ai-agents/${brainId}/simulations` : null;

export const createSimulationUrl = (path: string, requestId: string) =>
  `${path}?${CREATE_SIMULATION_PARAM}=${encodeURIComponent(requestId)}`;

export const stashCreateRequest = (requestId: string, request: CarriedCreateRequest) =>
  safeLocalStorageWrite(
    CREATE_SIMULATION_CONTEXT_KEY,
    JSON.stringify({ id: requestId, ...request } satisfies StashedCreateRequest)
  );

export const takeCreateRequest = (requestId: string): CarriedCreateRequest => {
  const stashed = safeLocalStorageParse<Partial<StashedCreateRequest>>(
    safeLocalStorageRead(CREATE_SIMULATION_CONTEXT_KEY)
  );
  if (stashed?.id !== requestId) {
    return { startingContext: '', transcript: '' };
  }
  safeLocalStorageRemove(CREATE_SIMULATION_CONTEXT_KEY);
  return { startingContext: stashed.startingContext || '', transcript: stashed.transcript || '' };
};

export const useCreateSimulationRequest = (): string | null =>
  new URLSearchParams(useLocation().search).get(CREATE_SIMULATION_PARAM);

export const searchWithoutCreateSimulation = (search: string): string => {
  const params = new URLSearchParams(search);
  params.delete(CREATE_SIMULATION_PARAM);
  const rest = params.toString();
  return rest ? `?${rest}` : '';
};
